import { getJson } from './client'
import type { FunnelReport, PillarView } from '../types/funnel'

// The activity funnel (the signed-in person's own; the API decides who they are) and the five pillars
// every measurement files under.
const scout = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout`

export const funnelApi = {
  /** `weeks` is the trailing window; omitted = the API's default quarter. */
  view: (spoke: string, weeks?: number) => getJson<FunnelReport>(`${scout(spoke)}/funnel`, weeks ? { weeks } : undefined),
  pillars: (spoke: string) => getJson<PillarView[]>(`${scout(spoke)}/pillars`),
}
